import { render, staticRenderFns } from "./AdminUserGamesElement.vue?vue&type=template&id=2b96eebc&scoped=true"
import script from "./AdminUserGamesElement.vue?vue&type=script&lang=js"
export * from "./AdminUserGamesElement.vue?vue&type=script&lang=js"
import style0 from "./AdminUserGamesElement.vue?vue&type=style&index=0&id=2b96eebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b96eebc",
  null
  
)

export default component.exports